import { APICallV3Post } from 'api/APICall';

class PromocodeAPICall extends APICallV3Post {
    _method = 'promo/validate';
}

export { PromocodeAPICall };
